/**
 * 用量管理 ↔ 服務啟用的雙向連動判定（管理方案彈窗）。
 *
 * 不變式：任一服務啟用中 ⟹ 用量管理必須啟用。
 * 整窗一次儲存，因此兩個方向都以「彈窗當前（未儲存）狀態」判定，不看伺服器已儲存值——
 * 否則使用者在窗內打開用量管理後服務開關仍鎖著，得先存一次、等重載回來才能再開服務、
 * 再存第二次，與「全部儲存」的批次設計矛盾。
 * 規格見 specs/manage_plan_modal.feature。
 */

/**
 * 用量管理當前啟用狀態。
 * 以 UsagePanel 回報的當前值（usageInfo.payload.activate）為準；尚未回報（載入中／
 * 剛開窗）時退回伺服器值 usageData.activate，避免服務開關短暫誤解鎖。
 */
export const resolveUsageEnabled = (usageInfo, usageData) =>
  usageInfo ? !!usageInfo.payload?.activate : !!usageData?.activate;

/**
 * 彈窗內是否有服務為啟用狀態。
 * 以各卡片回報的 payload.activate 為準，不可改用席位總和（activeSeatTotal）：
 * 後者把無席位服務算 1 席、把「啟用但席位填 0」算 0 席，兩種情況都會誤判。
 */
export const hasActiveService = (cardMap = {}) =>
  Object.values(cardMap).some((c) => c?.payload?.activate === true);

/**
 * 用量未啟用時不可開通服務。
 * 已啟用中的服務豁免此閘門，讓管理者仍能收拾「用量停用但服務啟用中」的存量資料。
 */
export const isUsageBlocked = ({ usageEnabled, activate }) =>
  !usageEnabled && !activate;

// 服務開關是否 disabled：無權限／該服務未設定方案／用量閘門。
export const isServiceSwitchDisabled = ({
  readOnly,
  hasPlan,
  usageEnabled,
  activate,
}) => !!readOnly || !hasPlan || isUsageBlocked({ usageEnabled, activate });

/**
 * 用量管理開關是否鎖住「停用」方向。
 * 只鎖停用：目前已停用時仍可開啟（含補救上述存量不一致資料）。
 */
export const isUsageSwitchLockedOff = ({ anyServiceActive, activate }) =>
  !!anyServiceActive && !!activate;
